/* eslint-disable */

/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Drivers Portal (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Spin, Table, notification } from 'antd';
import React, { useEffect, useState } from 'react';

import { _get_wallet_matrix, _get_wallet_report } from "common/axios_services";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";

function WalletReport() {
    const [spinnerLoading, setSpinnerLoading] = useState(true);
    const [wise9ja, setWise9ja] = useState([]);
    const [walletMatrix, setWalletMatrix] = useState(false);
    const jwt = localStorage.konnect_admin_token;

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: '',
            placement: 'bottomRight',
            description:
                message,
        });
    };
    if (!jwt) {
        openNotificationWithIcon('error', 'Unauthorized')
        return navigate('/')
    }
    const getWise9jaReport = async () => {
        try {
            const fetchAllWise9ja = await _get_wallet_report()
            setSpinnerLoading(false)
            setWise9ja(fetchAllWise9ja.data.data);
        } catch (err) {
            setSpinnerLoading(false)
            if (err.response) {
                if (err.response === "Unauthorized") {
                    window.location.reload()
                    openNotificationWithIcon('error', err.response.data.message);
                } else {
                    openNotificationWithIcon('error', err.response.data.message);
                }
            } else {
                openNotificationWithIcon('error', err.message);
            }
        }
    }
    let data = wise9ja.map((trans, index) => {
        return {
            key: index,
            month: trans.month,
            users: <NumericFormat thousandSeparator={true} displayType={'text'} value={Number(trans?.transactions)} />,
            balanceCF: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans?.bal_cf) * 1)} />,
            credit: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans?.credit_bal) * 1)} />,
            debit: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans?.debit_bal) * 1)} />,
            balance: <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(trans?.total_balance) * 1)} />,
            action: <Link to={`/report/wallet/${trans.created_month}`}>View</Link>,
        }
    });
    const columns = [
        {
            title: 'Month',
            dataIndex: 'month',
        },
        {
            title: 'Transaction(s)',
            dataIndex: 'users',
            align: 'center'
        },
        {
            title: 'BAL C/F (NGN)',
            dataIndex: 'balanceCF',
            align: 'right'
        },
        {
            title: 'Credit (NGN)',
            dataIndex: 'credit',
            align: 'right'
        },
        {
            title: 'Debit(NGN)',
            dataIndex: 'debit',
            align: 'right'
        },
        {
            title: 'Balance(NGN)',
            dataIndex: 'balance',
            align: 'right'
        },
    ];
    const getWalletMatrix = async () => {
        try {
            const wallet_matrix = await _get_wallet_matrix()
            setWalletMatrix(wallet_matrix.data.data)
        } catch (err) {
            if (err.response) {
                if (err.response.data.message === "Unauthorized") {
                    localStorage.removeItem('konnect_admin_token')
                    navigate('/')
                    openNotificationWithIcon('error', err.response.data.message)
                } else {
                    openNotificationWithIcon('error', err.response.data.message)
                }
            } else {
                openNotificationWithIcon('error', err.message)
            }
        }
    }
    useEffect(() => {
        getWise9jaReport()
        getWalletMatrix()
    }, [])

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={4}>
                <Grid container spacing={3} pb={6}>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                color="dark"
                                icon="weekend"
                                title="Total Transactions"
                                count={walletMatrix ? <span style={{ fontSize: "16px", fontWeight: "bold" }}><NumericFormat thousandSeparator={true} displayType={'text'} value={Number(walletMatrix?.transactions)} /> </span> : "0"}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                icon="leaderboard"
                                title="Total Credit"
                                count={walletMatrix ? <span style={{ fontSize: "16px", fontWeight: "bold" }}> <span style={{ fontWeight: "normal", fontSize: "12px" }}>NGN</span>  <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(walletMatrix?.credit_bal) * 1)} /> </span> : "0"}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                icon="leaderboard"
                                title="Total Debit"
                                count={walletMatrix ? <span style={{ fontSize: "16px", fontWeight: "bold" }}> <span style={{ fontWeight: "normal", fontSize: "12px" }}>NGN</span>  <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(walletMatrix?.debit_bal) * 1)} /> </span> : "0"}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDBox mb={1.5}>
                            <ComplexStatisticsCard
                                icon="leaderboard"
                                title="Total Balance"
                                count={walletMatrix ? <span style={{ fontSize: "16px", fontWeight: "bold" }}> <span style={{ fontWeight: "normal", fontSize: "12px" }}>NGN</span>  <NumericFormat thousandSeparator={true} displayType={'text'} value={Math.round(Number(walletMatrix?.total_balance) * 1)} /> </span> : "0"}
                            />
                        </MDBox>
                    </Grid>
                </Grid>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" >
                                <MDTypography variant="h6" color="white">
                                    Wallet Reports
                                </MDTypography>
                            </MDBox>
                            <MDBox py={3} px={2}>
                                <Spin tip="Loading..." spinning={spinnerLoading}>
                                    <React.Fragment>
                                        <>
                                            <div className="table-responsive">
                                                <Table columns={columns} pagination={false} dataSource={data} bordered />
                                            </div>
                                        </>
                                    </React.Fragment>
                                </Spin>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout >
    );

};

export default WalletReport;